import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { InvoiceData } from "../types";

export const updateInvoiceApi = (userId: string, invoice: InvoiceData) =>
  webApiWithResponse<string>({
    method: "PUT",
    url: "accounting/updinvoice",
    params: {
      userId,
    },
    data: invoice,
  });

export default updateInvoiceApi;
